import * as React from "react";
import { Box, FormControlLabel, Checkbox } from "@mui/material";
import { getPdcDueReport, getRentDueReport } from "state/apis";
import "./index.css";
import { Grid } from "@mui/material";
import moment from "moment";
import DefaultProperty from "components/DefaultProperty";
import { useSelector } from "react-redux";
import GetAppIcon from "@mui/icons-material/GetApp";
import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { formatAmount } from "utils/constants";

const PdcDueDates = () => {
    const propertyName = useSelector((state) => state.global.propertyName);
    const property = useSelector((state) => state.global.defaultProperty);
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const currentMonth = moment().format("YYYY-MM");
    const [propertyId, setPropertyId] = React.useState(property);

    const [filter, setFilter] = React.useState({
        monthValue: currentMonth,
    });

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        }

        setIsLoading(false);
    }, []);
    React.useEffect(() => {
        setIsLoading(true);
        fetchData(propertyId);

        setIsLoading(false);
    }, [filter.monthValue]);

    const fetchData = async (id) => {
        try {
            const res = await getPdcDueReport({ property: id, monthValue: filter.monthValue });
            setData(res.data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setIsLoading(false);
        }
    };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };

    const handleMonth = (date) => {
        if (!date) return;

        setFilter((prevData) => ({
            ...prevData,
            monthValue: date ? date.format("YYYY-MM") : null,
        }));
    };

    const handleAllProperty = (e) => {
        let value = e.target.checked;
        if (value) {
            setPropertyId("");
            fetchData("");
        } else {
            fetchData(property);
            setPropertyId(property);
        }
    };

    return (
        <Box m="1.5rem 2.5rem" mb={5}>
            <Box display="flex" justifyContent="flex-end" pt={0} paddingLeft={0}>
                <Grid container spacing={1} p={"5px"} alignItems="center">
                    <Grid item xs={2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={data.vacant}
                                    onChange={(e) => handleAllProperty(e)}
                                    name="vacant"
                                    color="primary"
                                />
                            }
                            label="All properties"
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={"Month"}
                                views={["month", "year"]}
                                name="month"
                                onChange={handleMonth}
                                value={filter.monthValue ? dayjs(filter.monthValue) : null}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs></Grid>

                    <Grid item xs="auto">
                        <Button
                            href={`${process.env.REACT_APP_BASE_URL}contract-registration/download-pdc-xlsx/${property}?month=${filter.monthValue}`}
                            target="_blank"
                            variant="contained"
                            className="download-btn"
                            sx={{
                                marginRight: "auto",
                                backgroundColor: "green",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "darkgreen",
                                },
                            }}
                        >
                            XLSX <GetAppIcon />
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            {!property && (
                <DefaultProperty
                    open={openDefaultProperty}
                    onClose={() => handleCloseDefaultProperty}
                />
            )}

            <div className="report-container">
                <table border="1" cellPadding="5" cellSpacing="0">
                    <thead>
                        <tr>
                            <th colSpan={11} style={{ textAlign: "center" }}>
                                {propertyName}
                            </th>
                        </tr>

                        <tr>
                            <th style={{ textAlign: "center" }}>PROPERTY NAME</th>
                            <th style={{ textAlign: "center" }}>UNIT</th>
                            <th style={{ textAlign: "center" }}>TENANT NAME</th>
                            <th style={{ textAlign: "center" }}>TENANT CONTACT</th>
                            <th style={{ textAlign: "center" }}>BANK</th>
                            <th style={{ textAlign: "center" }}>TYPE</th>
                            <th style={{ textAlign: "center" }}>AMOUNT</th>
                            <th style={{ textAlign: "center" }}>CHEQUE DATE</th>
                            <th style={{ textAlign: "center" }}>CHEQUE SERIALS NUMBER</th>
                            <th style={{ textAlign: "center" }}>CONTRACT FROM</th>
                            <th style={{ textAlign: "center" }}>CONTRACT TO</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data && data.length ? (
                            <>
                                {data.map((val, index) => (
                                    <tr key={index}>
                                        <td>{val.propertyName}</td>
                                        <td>{val.unitNumber}</td>
                                        <td>{val.tenantName}</td>
                                        <td>{val.contact1 !== null ? val.contact1 : "-"}</td>
                                        <td>{val.bankName}</td>
                                        <td>{val?.type === "rent" ? "Rent" : "Deposit"}</td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(Number(val?.amount))}
                                        </td>
                                        <td>
                                            {val.chequeDate
                                                ? moment(val.chequeDate).format("DD/MM/YYYY")
                                                : ""}
                                        </td>
                                        <td>{val.chequeSerialNumber}</td>
                                        <td>
                                            {val.contractFrom
                                                ? moment(val.contractFrom).format("DD/MM/YYYY")
                                                : ""}
                                        </td>
                                        <td>
                                            {val.contractTo
                                                ? moment(val.contractTo).format("DD/MM/YYYY")
                                                : ""}
                                        </td>
                                    </tr>
                                ))}
                            </>
                        ) : (
                            <tr>
                                <td colSpan="10" style={{ textAlign: "center" }}>
                                    No data found
                                </td>
                            </tr>
                        )}

                        <tr>
                            <td colSpan={11}></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Box>
    );
};

export default PdcDueDates;
